import posthog from 'posthog-js'

/**
 * Churn-flow diagnostic events (settings → downgrade to Free). Client-side only (posthog-js);
 * they measure the save funnel: opened → reason → offer shown → offer accepted / cancelled.
 * Diagnostics — no source-of-truth metric depends on them.
 */
export type ChurnEvent =
  | 'churn_flow_opened'
  | 'churn_flow_dismissed'
  | 'churn_reason_selected'
  | 'churn_offer_shown'
  | 'churn_offer_accepted'
  | 'churn_offer_declined'
  | 'churn_cancelled'
  | 'churn_plan_resumed'

export const captureChurnEvent = (event: ChurnEvent, properties: Record<string, any> = {}): void => {
  try {
    posthog.capture(event, properties)
  } catch {
    // Diagnostics must never break the app.
  }
}
